export default __webpack_public_path__ + "img/list.ff8fd86d.svg";